const RedeemStatus = {
   RECORDED : 'RECORDED',
   REDEEMED : 'REDEEMED',
 
}
export default RedeemStatus